import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import { getTranslations } from '../../api/fetchTranslations';
import { Layout } from '../../components/layout/layout';
import Loader from '../../components/loader/loader';
import TranslationsProvider from '../../components/translationsProvider';
import { Router } from '../../router';
import { StoreProvider } from '../../store/store';

const App = ({ config }) => {
  const [translations, setTranslations] = React.useState({});
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    const translations = async () => {
      const lang = config.language ? config.language.split('_').shift() : 'en';
      const data = await getTranslations(lang);
      setTranslations(data);
      setIsLoading(false);
    };

    translations();
  }, [config]);

  return (
    <BrowserRouter>
      <StoreProvider config={config}>
        <TranslationsProvider keys={translations}>
          <Loader hideChildren isLoadingAPIs={[isLoading]}>
            <Layout>
              <Router />
            </Layout>
          </Loader>
        </TranslationsProvider>
      </StoreProvider>
    </BrowserRouter>
  );
};

export default App;
